export default __webpack_public_path__ + "static/media/OSMOS_CALCE_C2_GRIP_60X120_01.141bebab.jpg";